import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { ChevronLeft } from '@material-ui/icons';
import { ChevronRight } from '@material-ui/icons';
import { Today } from '@material-ui/icons';
import { InputAdornment } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import { InlineDatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import { translation } from '../i18n';

interface Props {
  required?: boolean,
  fullWidth?: boolean,
  disableFuture?: boolean,
  disablePast?: boolean,
  label?: string,
  className?: string,
  value: string | undefined,
  shouldDisableDate?: (date: Date) => boolean,
  onChange: (value: string) => void,
  invalidDateMessage?: string,
}

type PropsWithStyle = Props & WithStyles<''>;

class CustomDatePicker extends React.Component<PropsWithStyle> {

  public render() {
    let picker: any;
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <InlineDatePicker
          keyboard={true}
          required={this.props.required}
          fullWidth={this.props.fullWidth}
          className={this.props.className}
          disableFuture={this.props.disableFuture}
          disablePast={this.props.disablePast}
          shouldDisableDate={this.props.shouldDisableDate}
          label={this.props.label}
          format="DD.MM.YYYY"
          mask={(value: any) => (value ? [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/] : [])}
          value={this.props.value ? moment(this.props.value) : null}
          onChange={(date: any) => this.props.onChange(date.format('YYYY-MM-DD'))}
          animateYearScrolling={false}
          leftArrowIcon={<ChevronLeft/>}
          rightArrowIcon={<ChevronRight/>}
          ref={(node: any) => picker = node}
          invalidDateMessage={this.props.invalidDateMessage}
          minDateMessage={translation.t('customDatePicker.minDateMsg', {minDate: (this.props.disablePast ? moment().subtract(1, 'days').format('DD.MM.YYYY') : '01.01.1900')})}
          maxDateMessage={translation.t('customDatePicker.maxDateMsg', {maxDate: (this.props.disableFuture ? moment().add(1, 'days').format('DD.MM.YYYY') : '01.01.2100')})}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={e => picker.open(e)}>
                  <Today/>
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

export default withStyles({})(CustomDatePicker);
